export const FEEDBACK_STATUSES = [
  { code: 'submitted', name: 'Submitted', color: '#F59E0B' },
  { code: 'in_review', name: 'In review', color: '#2563EB' },
  { code: 'reviewed', name: 'Reviewed', color: '#16A34A' },
]

const UNKNOWN_STATUS_COLOR = '#6B7280'

export function getFeedbackStatusColor(code) {
  const status = FEEDBACK_STATUSES.find(item => item.code === code)
  return status ? status.color : UNKNOWN_STATUS_COLOR
}

export function getFeedbackStatusName(status) {
  if (status && status.name) return status.name
  const knownStatus = FEEDBACK_STATUSES.find(item => item.code === (status && status.code))
  return knownStatus ? knownStatus.name : (status && status.code) || '-'
}
